// KeywordsDialog.jsx
// Client: vmfive
// Version: 1.0.0
// Modal-based keyword editor with multi-line input and split functionality
//
// Usage:
//   <KeywordsDialog
//     label="包含關鍵字"
//     value={['購物', '優惠']}
//     onChange={(keywords) => setKeywords(keywords)}
//   />
//
// The component renders a trigger button showing keyword count.
// Clicking opens a Modal with a textarea (one keyword per line)
// and a split tool to break comma/delimiter-separated text into lines.

import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import './KeywordsDialog.css';

export default function KeywordsDialog({
  label,
  value = [],
  onChange,
  placeholder = '每行輸入一個關鍵字',
}) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState('');
  const [splitChar, setSplitChar] = useState(',');

  const count = value.length;

  const handleOpen = () => {
    setDraft(value.join('\n'));
    setOpen(true);
  };

  const handleSave = () => {
    const keywords = draft
      .split('\n')
      .map((s) => s.trim())
      .filter(Boolean);
    onChange(keywords);
    setOpen(false);
  };

  const handleSplit = () => {
    if (!splitChar) return;
    const lines = draft
      .split('\n')
      .flatMap((line) => line.split(splitChar))
      .map((s) => s.trim())
      .filter(Boolean);
    setDraft(lines.join('\n'));
  };

  const lineCount = draft.split('\n').filter((s) => s.trim()).length;

  return (
    <>
      <div className="form-group">
        <label>{label}</label>
        <button type="button" className={`keywords-trigger ${count === 0 ? 'keywords-trigger--empty' : ''}`} onClick={handleOpen}>
          <span>{count > 0 ? `${count} 個關鍵字` : '點擊設定...'}</span>
          <span className="keywords-trigger__count">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 10h12M12 6l4 4-4 4" />
            </svg>
          </span>
        </button>
      </div>

      {open && (
        <Modal
          title={label}
          size="md"
          onClose={() => setOpen(false)}
          footer={
            <>
              <Button variant="secondary" onClick={() => setOpen(false)}>取消</Button>
              <Button onClick={handleSave}>儲存</Button>
            </>
          }
        >
          <textarea
            className="keywords-dialog__textarea"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder={placeholder}
            autoFocus
          />
          <div className="keywords-dialog__toolbar">
            <span className="keywords-dialog__count">{lineCount} 個關鍵字</span>
            <div className="keywords-dialog__split-group">
              <span className="keywords-dialog__split-label">以</span>
              <input
                className="keywords-dialog__split-input"
                value={splitChar}
                onChange={(e) => setSplitChar(e.target.value)}
                maxLength={5}
              />
              <span className="keywords-dialog__split-label">拆分</span>
              <Button variant="secondary" size="sm" onClick={handleSplit}>執行</Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
